import service from '@/services/bills/BillsService'

export const billsModule = {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    billsList: [],
    loadingItems: false,
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 10,
    },
  },
  mutations: {
    SET_LIST(state, payload) {
      if (payload.current_page) {
        state.pagination.current_page = payload.current_page
        state.pagination.last_page = payload.last_page
      }
      state.billsList = payload.data ?? payload
    },
    SET_LOADING(state) {
      state.loadingItems = !state.loadingItems
    },
  },
  actions: {
    async getBills({ commit }, payload) {
      try {
        commit('SET_LOADING')
        let response = await service.getBills(payload)
        await commit('SET_LIST', response)
      } finally {
        commit('SET_LOADING')
      }
    },
    async getBill(context, payload) {
      let data = await service.getBill(payload)
      return data
    },
    async getPendingBillsResumePDV(context, payload) {
      let response = await service.getPendingBillsResumePDV(payload)
      return response
    },
  },
}
